import Select from "react-select";

const Dropdown = ({
  label,
  value,
  onChange,
  options,
  placeholder,
  required = false,
}) => {
  return (
    <div className="mb-1 mb-md-2">
      {label && (
        <label className="d-block text-white mb-1 mb-md-2  fontSize14Medium lineHeight24 ">
          {label}
          {required && <span className="text-white">*</span>}
        </label>
      )}

      <div className="position-relative">
        <Select
          value={value || null}
          onChange={onChange}
          options={options}
          placeholder={placeholder}
          className="custom-select-container"
          classNamePrefix="custom-select"
          instanceId={`select-${
            label?.replace(/\s+/g, "-").toLowerCase() || "dropdown"
          }`}
        />
      </div>
    </div>
  );
};

export default Dropdown;
